import { ConsumptionTimeFrame, Report } from '@vae/server/dist/client'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
	observedReport: Report
	previousReport: Report | undefined | null
	averages:
		| {
				id: number
				personCount: number
				from: string
				to: string
				totalConsumption: number
				totalCO2: number
				heatingCO2: number
				timeframe: ConsumptionTimeFrame
				totalHeatingConsumption: number
				// eslint-disable-next-line no-mixed-spaces-and-tabs
		  }
		| null
		| undefined
}

const Heating = (props: Props) => {
	const { observedReport, previousReport } = props
	const { t } = useTranslation('pages_monthlyReport')

	const heatingDifference = useMemo(() => {
		if (!previousReport) return observedReport.heatingConsumption
		return observedReport.heatingConsumption - previousReport.heatingConsumption
	}, [observedReport, previousReport])

	if (!observedReport) return null

	const temperatureDecrease = Math.max(0, observedReport.temperature - 21)
	const potentialSavings = Math.round(
		temperatureDecrease * 0.05 * observedReport.heatingConsumption
	)

	return (
		<div className='card'>
			<div className='contents'>
				<div className='title'>{t('yhteenveto')}</div>
				<div className='saving-status'>
					<div className='summary-text'>
						{previousReport && heatingDifference > 0 ? (
							<p>{t('suurempi')}</p>
						) : (
							<p>{t('lammitys')}</p>
						)}
					</div>
				</div>
				{observedReport.temperature > 21 && (
					<>
						<div className='title'>{t('ehdotus')}</div>
						<div className='suggestion'>
							<div className='suggestion-text'>
								{observedReport.temperature !== previousReport?.temperature ? (
									<>
										<p>{t('ehdotus')} </p>
										{potentialSavings}
									</>
								) : (
									<>
										<p>{t('varmista')}</p>
									</>
								)}
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	)
}

export default Heating
